import api from 'service/api'

const dponetAPINotTreatError = api.create('supplierPortal', false)
const dponetAPI = api.create('supplierPortal')

const showByToken = async ({ token }) =>
  await dponetAPINotTreatError.get(`/company_suppliers/${token}/show_by_token`)

const identify = async () => {
  return await dponetAPINotTreatError.get(`/company_suppliers/identify`)
}

const validateByDocument = async ({ token, ...params }) => {
  return await dponetAPINotTreatError.post(
    `/company_suppliers/${token}/validate_by_document`,
    params,
  )
}

const validateByEmail = async ({ token, ...params }) => {
  return await dponetAPINotTreatError.post(
    `/company_suppliers/${token}/validate_by_email`,
    params,
  )
}

const confirmData = async ({ token, ...params }) => {
  return await dponetAPINotTreatError.post(
    `/company_suppliers/${token}/confirm_data`,
    params,
  )
}

const stats = async ({ id = '' }) => {
  return await dponetAPI.get(`/company_suppliers/${id}/stats`)
}

export default {
  confirmData,
  identify,
  showByToken,
  stats,
  validateByDocument,
  validateByEmail,
}
